import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {change, Field} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {RESOURCES as productResources} from '../fuseProductsResourceMap';
import {checkTokenStatus} from '../shared/tokenFunctions';
import VirtualizedSelectInput from '../components/VirtualizedSelectInput';

/**
 * A Virtualized SelectInput form component with Product Unit choices populated from Product Type value.
 *
 */
class ProductUnitForAliasDependentSelectInput extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sourceParam: null,
            selectChoices: [],
            selectedId: null,
        };

        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    componentDidMount() {
        // Set the dependentProp value and retrieve data
        this.setState({
            sourceParam: this.props[this.props['dependentProp']]
        });
        this.fetchData(this.props);
    }

    componentWillReceiveProps(nextProps) {
        // If dependentProp changes value, update the value
        const propName = this.props['dependentProp'];
        if (nextProps[propName] !== this.props[propName]) {
            this.setState({
                sourceParam: nextProps[propName],
                selectedId: null,
            });
            this.props.dispatch(change('record-form', 'product_unit_id', ''));
        }
    }

    componentDidUpdate(prevProps) {
        // If dependentProp value changes, retrieve data
        const propName = this.props['dependentProp'];
        if (prevProps[propName] !== this.props[propName]) {
            this.setState({
                selectChoices: []
            });
            this.fetchData(this.props);
        }
    }

    fetchData(props) {
        this.setState({
            selectChoices: []
        });
        // Assemble the URI
        const params = {
            filter: {
                type: encodeURIComponent(props[props['dependentProp']])
            },
            pagination: {page: 1, perPage: 10000},
            sort: {field: "name", order: "ASC"}
        };
        const resource = productResources.ProductUnitsForAlias.GET_LIST(params);

        // Retrieve the data and assign results to the Select choices
        import('../shared/functions')
            .then(functions => {
                const tokenStatus = checkTokenStatus(null);
                if (tokenStatus.expired) {
                    return;
                }
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        let choices = this.assembleChoiceNames(result.data.payload);
                        this.setState({
                            selectChoices: choices
                        });
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    assembleChoiceNames(choices) {
        for (let choice of choices) {
            const id = choice.id;
            const name = (choice.name) ? ' - ' + choice.name : '';
            const unit = (choice.unit_type) ? ' (' + choice.unit_type + ')' : '';
            const brand = (choice.brand) ? ' - ' + choice.brand : '';
            choice.name = id + name + unit + brand;
        }
        return choices;
    }

    handleSelectChange(event, index) {
        const selectedId = index;
        // Retrieve the Product Unit from the choices list based on the selected ID
        if (selectedId) {
            const productUnit = this.state.selectChoices.find(p => p.id === selectedId);
            if (productUnit) {
                this.setState({
                    selectedId: selectedId
                });
                this.props.dispatch(change('record-form', 'product_unit_id', productUnit.id));
            }
        } else {
            this.setState({
                selectedId: ''
            });
            this.props.dispatch(change('record-form', 'product_unit_id', ''));
        }
    }

    render() {
        return (
            <span>
                <Field name="product_unit_id"
                       component={VirtualizedSelectInput}
                       choices={this.state.selectChoices}
                       label={this.props.label}
                       optionText="name"
                       onChange={this.handleSelectChange}
                       allowEmpty
                       options={{
                           className: "full-width",
                           clearable: false,
                           placeholder: "Select a Product",
                       }}
                />
            </span>
        );
    }
}

ProductUnitForAliasDependentSelectInput.propTypes = {
    addField: PropTypes.bool.isRequired,
    dependentProp: PropTypes.string,
    selectedId: PropTypes.string,
    selectedName: PropTypes.string,
};

ProductUnitForAliasDependentSelectInput.defaultProps = {
    addField: true,
    dependentProp: null,
    selectedId: null,
    selectedName: '',
};

const enhance = compose(
    connect()
);

export default enhance(ProductUnitForAliasDependentSelectInput);



// WEBPACK FOOTER //
// ./src/Fuse/components/ProductUnitForAliasDependentSelectInput.js